 import React from "react";
import "./ProtectedWrapper.css";

const ProtectedWrapper = ({ children, isLoggedIn }) => {
  if (isLoggedIn) {
    return children;
  }

  return (
    <>
      <div className="protected-content" style={{ filter: 'blur(5px)', pointerEvents: 'none' }}> 
        {children}
      </div>

      <div className="modal-overlay">
        <div className="modal-content">
          <h2>Access Required</h2>
          <p>Please login or sign up to continue.</p>

          <div className="modal-buttons">
            <button onClick={() => (window.location.href = "/login")}>
              Login
            </button>

            <button onClick={() => (window.location.href = "/signup")}>
              Sign Up
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProtectedWrapper;